import { Transaction } from "@common/types/transaction";
import { fullDateLongFormat } from "@common/helpers/date";
import { currencyFormatter } from "@common/helpers/currency";
import { format } from "date-fns";

export const createTransactionDescription = (
    transaction: Transaction,
): string => {
    const { amount, memo, bankDescription, date } = transaction;
    const dateString = format(date, fullDateLongFormat);
    const amountString = currencyFormatter.format(amount);
    return `${amountString} - ${bankDescription ?? memo} on ${dateString}`;
};
